var DevOps = "DevOps";
var Gaming = "Gaming";
var Migration = "Migrasi";
var Other = "Lainnya";
var useCase = {
	"Use case": "Kasus Penggunaan",
	"AI & machine learning": "AI & Machine Learning",
	"Batch processing": "Pemrosesan Batch",
	"Big data, analytics, & business intelligence": "Big Data, Analisis & Kecerdasan Bisnis",
	"Business applications - Microsoft": "Aplikasi Bisnis - Microsoft",
	"Business applications - Oracle": "Aplikasi Bisnis - Oracle",
	"Business applications - Other": "Aplikasi Bisnis - Lainnya",
	"Business applications - SAP": "Aplikasi Bisnis - SAP",
	"Content delivery": "Pengiriman Konten",
	DevOps: DevOps,
	Gaming: Gaming,
	"Internet of things": "Internet of Things",
	"Learning & certification": "Pembelajaran & Sertifikasi",
	"Media services": "Layanan Media",
	Migration: Migration,
	"Mobile applications": "Aplikasi Seluler",
	Other: Other,
	"Storage & backup": "Penyimpanan & Cadangan",
	"Websites & web apps": "Situs Web & Aplikasi Web"
};

export { DevOps, Gaming, Migration, Other, useCase as default };
